module.exports = __webpack_public_path__ + "img/LOGO ITALVEN (1).372670db.png";